import * as React from 'react';
export const SvgFolderImport = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M0 15c1.5-1.5 3-3.1 6-3v2.1l5-3.5L6 7v2a6.08 6.08 0 00-6 6M16 2.79v7.42a.935.935 0 01-.93.93h-3.1l.76-.53L5 5.05v3.03a7.06 7.06 0 00-2 .62V.93A.935.935 0 013.93 0h3.71a.928.928 0 01.93.93v.93h6.5a.928.928 0 01.93.93z' })));
};
export default SvgFolderImport;
